import type { PagedResultDto } from "@services/dto/pagedResultDto"
import pinkBookService from "@services/pinkBook/pinkBookService"
import { action, makeAutoObservable, observable } from "mobx"

class PinkBookStore {
  @observable isLoading!: boolean
  @observable detailData!: any
  @observable tableData!: PagedResultDto<any>

  @observable tableDataBatch!: PagedResultDto<any>
  @observable detailDataBatch!: any
  @observable isLoadingBatch!: boolean

  @observable tableDataBatchProduct!: PagedResultDto<any>
  @observable tableDataNotification!: PagedResultDto<any>
  @observable tableDataNotifyHistory!: PagedResultDto<any>
  @observable isLoadingNotification!: boolean
  @observable tableDataPinkBookStatus: any[] = []
  @observable detailDataPinkBookStatus!: any
  @observable isLoadingPinkBookStatus!: boolean
  @observable tableDataPinkBookContractDetailSetting: any[] = []
  @observable detailDataPinkBookContractDetailSetting!: any
  @observable isLoadingPinkBookContractDetailSetting!: boolean
  @observable tableDataPinkBookDocument: any[] = []
  @observable detailDataPinkBookDocument!: any
  @observable isLoadingPinkBookDocument!: boolean
  @observable pinkBookAllContracts: PagedResultDto<any> = { items: [], totalCount: 0 }

  constructor() {
    makeAutoObservable(this)

    this.tableDataBatch = { items: [], totalCount: 0 }
    this.tableData = { items: [], totalCount: 0 }
    this.tableDataNotification = { items: [], totalCount: 0 }
    this.pinkBookAllContracts = { items: [], totalCount: 0 }
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await pinkBookService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  // BATCH
  @action
  async createOrUpdateBatch(body: any) {
    if (!body.id) {
      const result = await pinkBookService.createBatch(body)
      this.detailDataBatch = result
      this.tableDataBatch.items.push(result)
    } else {
      const result = await pinkBookService.updateBatch(body)
      this.detailDataBatch = result
      this.tableDataBatch.items = this.tableDataBatch.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }

  

  @action
  async newDetailBatch() {
    this.detailDataBatch = {
      id: 0,
    }
  }

  @action
  async deleteBatch(id: number) {
    await pinkBookService.deleteBatch(id)
  }
  @action
  async bulkDeleteBatch(id: number[]) {
    await pinkBookService.bulkDeleteBatch(id)
  }
  @action
  async getBatch(id: number) {
    const result = await pinkBookService.getBatch(id)
    this.detailDataBatch = result
  }

  @action
  async getAllBatch(params: any) {
    this.isLoadingBatch = true
    const result = await pinkBookService
      .getAllBatch(params)
      .finally(() => (this.isLoadingBatch = false))
    this.tableDataBatch = result
  }

  @action
  async getListPinkBookProduct(params: any) {
    const result = await pinkBookService.getListPinkBookProduct(params)
    return result
  }

  @action
  async getListPinkBookProductByBatchId(params: any) {
    this.isLoading = true
    const result = await pinkBookService.getListPinkBookProductByBatchId(params)
      .finally(() => (this.isLoading = false))
    // this.tableDataBatchProduct = result\
    this.pinkBookAllContracts = result
    return result
  }

  @action
  async getListPinkBookNotification(params: any) {
    const result = await pinkBookService.getListPinkBookNotification(params)
    this.tableDataNotification = result
  }

  @action
  async sendNotification(params: any) {
    this.isLoadingNotification = true
    const result = await pinkBookService.sendNotification(params)
      .finally(() => (this.isLoadingNotification = false))
    return result
  }

  @action
  async getNotifyHistory(params: any) {
    this.isLoading = true
    const result = await pinkBookService.getNotifyHistory(params)
      .finally(() => (this.isLoading = false))
    return result
  }

  @action
  async updateStatusPinkBookProduct(params: any) {
    const result = await pinkBookService.updateStatusPinkBookProduct(params)
    return result
  }

  @action
  async getDetailPinkBook(params: any) {
    const result = await pinkBookService.getDetailPinkBook(params)
    return result
  }

  @action
  async updatePinkBookDetail(params: any) {
    const result = await pinkBookService.updatePinkBookDetail(params)
    return result
  }

  @action
  async getListPinkBookStatus(params: any) {
    this.isLoadingPinkBookStatus = true
    const result = await pinkBookService.getListPinkBookStatus(params)
    .finally(() => (this.isLoadingPinkBookStatus = false))
    this.tableDataPinkBookStatus = result
    return result
  }

  @action
  async createOrUpdatePinkBookStatus(params: any) {
    this.isLoadingPinkBookStatus = true
    const result = await pinkBookService.createOrUpdatePinkBookStatus(params)
    .finally(() => (this.isLoadingPinkBookStatus = false))
    return result
  }

  @action
  async getDetailPinkBookStatus(id: number) {
    this.isLoadingPinkBookStatus = true
    const result = await pinkBookService.getDetailPinkBookStatus(id)
    .finally(() => (this.isLoadingPinkBookStatus = false))
    this.detailDataPinkBookStatus = result
    return result
  }

@action
async getListPinkBookContractDetailSetting() {
  this.isLoadingPinkBookContractDetailSetting = true

  const res = await pinkBookService
    .getListPinkBookContractDetailSetting()
    .finally(() => (this.isLoadingPinkBookContractDetailSetting = false))

  this.tableDataPinkBookContractDetailSetting = res || []
  return res
}


  @action
  async createOrUpdatePinkBookContractDetailSetting(params: any) {
    this.isLoadingPinkBookContractDetailSetting = true
    const result = await pinkBookService.createOrUpdatePinkBookContractDetailSetting(params)
    .finally(() => (this.isLoadingPinkBookContractDetailSetting = false))
    return result
  }

  @action
  async getDetailPinkBookContractDetailSetting(id: number) {
    this.isLoadingPinkBookContractDetailSetting = true
    const result = await pinkBookService.getPinkBookContractDetailSetting(id)
    .finally(() => (this.isLoadingPinkBookContractDetailSetting = false))
    this.detailDataPinkBookContractDetailSetting = result
    return result
  }

  @action
  async getListPinkBookDocument(params: any) {
    this.isLoadingPinkBookDocument = true
    const result = await pinkBookService.getListPinkBookContractDetailSetting(params)
    .finally(() => (this.isLoadingPinkBookDocument = false))
    this.tableDataPinkBookDocument = result
    return result
  }

  @action
  async createOrUpdatePinkBookDocument(params: any) {
    this.isLoadingPinkBookDocument = true
    const result = await pinkBookService.createOrUpdatePinkBookContractDetailSetting(params)
    .finally(() => (this.isLoadingPinkBookDocument = false))
    return result
  }

  @action
  async getDetailPinkBookDocument(id: number) {
    this.isLoadingPinkBookDocument = true
    const result = await pinkBookService.getPinkBookContractDetailSetting(id)
    .finally(() => (this.isLoadingPinkBookDocument = false))
    this.detailDataPinkBookDocument = result
    return result
  }
}

export default PinkBookStore
